/**
 * A frase da marca, num lugar só.
 *
 * ── Por que ela precisa de dono ───────────────────────────────────────────
 *
 * Era "Seu controle financeiro inteligente" e virou esta. Na hora da troca a
 * frase antiga estava em CINCO lugares: o cabeçalho do app, a tela de login,
 * o email de boas-vindas, a descrição no `index.html` e o título do README.
 *
 * Cinco cópias de uma frase é a armadilha 4 na sua forma mais chata: nada
 * quebra quando uma fica para trás, e o app passa a se apresentar de dois
 * jeitos dependendo de onde a pessoa entra. O email diria uma coisa e a tela
 * outra, e ninguém compara os dois lado a lado.
 *
 * Aqui moram as duas do frontend. O email é backend e o README é prosa, então
 * eles não podem importar daqui — `marca.test.ts` guarda que os três textos
 * continuam iguais.
 */

/** O que o app é, em uma linha. Escrita por ela. */
export const FRASE_DA_MARCA = 'IA que acompanha seu dinheiro hoje e prevê o amanhã';
